import "core-js/modules/es6.regexp.to-string";
import _typeof from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/typeof.js";
import _classCallCheck from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/classCallCheck.js";
import _createClass from "/data/svn/trpc_mqq/b-7412685b9a7147d19e21e6f723ad7dbb/input/1709611215905/bin/src/node_modules/@babel/runtime-corejs2/helpers/esm/createClass.js";
/**
 * Created by commyfeng on 2017/3/21.
 */
var parse = require('url-parse');
var Request = /*#__PURE__*/function () {
  function Request(url, data, options) {
    _classCallCheck(this, Request);
    if (typeof url === 'undefined') throw new TypeError('url 不能为空');
    if (_typeof(url) === 'object') {
      data = url;
      url = data.url;
      delete data.url;
      if (!url) throw new TypeError('没有找到url属性');
    }
    this._url = parse(url, true);
    this.data = data;
    this.options = options || {};
  }
  _createClass(Request, [{
    key: "url",
    get: function get() {
      return this._url.toString();
    },
    set: function set(url) {
      this._url = parse(url, true);
    }
  }, {
    key: "protocol",
    get: function get() {
      return this._url.protocol;
    },
    set: function set(val) {
      this._url.set('protocol', val);
    }
  }, {
    key: "hostname",
    get: function get() {
      return this._url.hostname;
    },
    set: function set(val) {
      this._url.set('hostname', val);
    }
  }, {
    key: "port",
    get: function get() {
      return this._url.port;
    },
    set: function set(val) {
      this._url.set('port', val);
    }
  }, {
    key: "pathname",
    get: function get() {
      return this._url.pathname;
    },
    set: function set(val) {
      this._url.set('pathname', val);
    }
  }, {
    key: "query",
    get: function get() {
      return this._url.query;
    },
    set: function set(val) {
      this._url.set('query', val);
    }
  }]);
  return Request;
}();
export default Request;